import { Controller } from "@hotwired/stimulus"

// Cycles decorative placeholder copy with a short fade. `interval` is how
// long each sentence stays fully visible before fading to the next.
// Pauses while the input is focused or has a value. Respects reduced motion.
export default class extends Controller {
  static targets = ["input", "label"]
  static values = {
    sentences: { type: Array, default: [] },
    interval: { type: Number, default: 3000 },
    fadeMs: { type: Number, default: 400 },
  }

  connect() {
    this.index = 0
    this.timer = null
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    if (this.sentencesValue.length === 0) return

    this.labelTarget.textContent = this.sentencesValue[0]
    this.sync()
  }

  disconnect() {
    this.stop()
  }

  sync() {
    const hasValue = this.inputTarget.value.trim().length > 0
    const focused = document.activeElement === this.inputTarget
    this.labelTarget.classList.toggle("is-concealed", hasValue || focused)

    if (hasValue || focused) {
      this.stop()
    } else if (!this.reducedMotion && this.sentencesValue.length > 1 && this.timer == null) {
      this.scheduleAdvance()
    }
  }

  scheduleAdvance() {
    this.stop()
    this.timer = window.setTimeout(() => this.advance(), this.intervalValue)
  }

  stop() {
    if (this.timer != null) {
      clearTimeout(this.timer)
      this.timer = null
    }
    this.labelTarget.classList.remove("is-fading")
  }

  advance() {
    this.timer = null
    if (this.sentencesValue.length < 2) return

    this.labelTarget.classList.add("is-fading")
    this.timer = window.setTimeout(() => {
      this.index = (this.index + 1) % this.sentencesValue.length
      this.labelTarget.textContent = this.sentencesValue[this.index]
      this.labelTarget.classList.remove("is-fading")
      // Wait for fade-in to finish, then dwell for `interval` again.
      this.timer = window.setTimeout(() => this.scheduleAdvance(), this.fadeMsValue)
    }, this.fadeMsValue)
  }
}
